import http from "@/utils/http";


export const VisitorPassageRecordLogApi = {
	selectVisitorPassageRecordLogPage(params) {
		return http.get(`/server//visitor/passageRecordLog/list`,params);
	},
}